import React, { useState } from "react";
import HamburgerIcon from "../../icons/hamburger-menu.js";
import TissueVaultLogo from "../../icons/tissue-vault-logo.js";
import profileImage from "../../assets/icons/profileImage.png";
import "../../common/phone-header/styles.css";
import Button from "../button/button.js";
import { useAuth } from "../../components/AuthProvider.js";
import DropdownPortal from "../../components/Utils/DropdownPortal.js";
import { useNavigate } from "react-router-dom";

const PhoneHeader = ({ toggleSidebar }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const auth = useAuth();

  const handleLogout = () => {
    auth.logOut();
    navigate("/Login");
    console.log("User logged out and redirected to login");
  };

  return (
    <div className="phone-header-container">
      <Button
        icon={<HamburgerIcon />}
        variant="default"
        children={undefined}
        onClick={toggleSidebar}
      />
      <TissueVaultLogo />
      <div onClick={() => setIsOpen(!isOpen)}>
        <img
          src={profileImage}
          alt="Profile"
          className="profile-image-container"
        ></img>
      </div>
      {isOpen && (
        <DropdownPortal>
          <div className="top-bar-menu-dropdown">
            {/* <Button
              variant="table"
              subVariant="primary-hover"
              style={{ width: "100%" }}
            >
              Account
            </Button>
            <Button
              variant="table"
              subVariant="primary-hover"
              style={{ width: "100%" }}
            >
              Settings
            </Button> */}
            <Button
              variant="table"
              subVariant="primary-hover"
              style={{ width: "100%" }}
              onClick={() => {
                setIsOpen(false);
                navigate("/Forgot");
              }}
            >
              Reset Password
            </Button>
            <Button
              variant="table"
              subVariant="failure"
              style={{ width: "100%" }}
              onClick={handleLogout}
            >
              Log Out
            </Button>
          </div>
        </DropdownPortal>
      )}
    </div>
  );
};

export default PhoneHeader;
